import React from 'react';
import { observer } from 'mobx-react-lite';
import { Collapse, IMInputText, IMSelect } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  IMFormStyled,
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
} from 'components/common/initiate-proposal/styles';
import { useSunLifeQuoteProposalInfoPageStore } from 'store/pages/quote/quote-proposal-info/sunLife/pageStore';
import { INCORPORATION_DATE_GUIDELINES } from 'global/utils/sponsor-validations/sunLife/incorporationDateValidation';
import { AlertStyled, SICWrapperStyled } from './styles';
import { SUN_LIFE_PROPOSAL_INFO_FORM_ID, SUN_LIFE_SIC_WARNING_ALERT_TEST_ID } from './constants';

const SunLifeQuoteProposalInfoForm: React.FC = observer(() => {
  const {
    proposalFormDelegate: { proposalForm, effectiveDatesOptions, sicWarningMessage, showIncorporationDate },
    proposalInfoDelegate: { domainProductLineItems, isDomainProductLinesLoading },
    isStepCompleted,
  } = useSunLifeQuoteProposalInfoPageStore();

  const showWarning = Boolean(sicWarningMessage);

  return (
    <IMFormStyled id={SUN_LIFE_PROPOSAL_INFO_FORM_ID} formController={proposalForm}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesOptions} disabled />
      <IMZipCodeFieldStyled size="s" disabled={isStepCompleted} />
      <IMZipStateFieldStyled size="s" disabled />
      <IMZipCountyFieldStyled size="s" disabled={isStepCompleted} />

      <FollowingSectionTitleStyled title="Additional Information" />
      {showIncorporationDate && (
        <IMInputText
          label="Incorporation Date"
          name="incorporationDate"
          size="full"
          htmlType="date"
          disabled
          additionalOptions={{
            guidelines: INCORPORATION_DATE_GUIDELINES,
            showGuidelinesByDefault: true,
          }}
        />
      )}
      <IMInputText label="Estimated Number of Eligible Employees" name="groupSize" size="full" disabled />
      <SICWrapperStyled>
        <IMSicSearch label="SIC Code" size="full" disabled />
        <Collapse show={showWarning}>
          <AlertStyled
            content={[sicWarningMessage]}
            title="Note"
            type="warning"
            data-test-id={SUN_LIFE_SIC_WARNING_ALERT_TEST_ID}
          />
        </Collapse>
      </SICWrapperStyled>

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </IMFormStyled>
  );
});

export default SunLifeQuoteProposalInfoForm;
